import { registerPlugin } from "@wordpress/plugins";
import { PluginSidebar,PluginSidebarMoreMenuItem} from "@wordpress/edit-post";
import { __ } from "@wordpress/i18n";
import App from './app';
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';
import { MemoryRouter } from "react-router-dom"; 

//Converted the Topic PNG file to SVG and the path is used in wp.element.createElement below.
const smileIcon = wp.element.createElement('svg', 
	{ 
		width: 20, 
		height: 20 
  },
  wp.element.createElement( 'g',
    { 
      transform: "translate(3.000000,21.000000) scale(0.013,-0.013)" 
    },
    wp.element.createElement( 'path',
    { 
      d: "M904 1621 c-138 -54 -368 -232 -491 -380 -61 -72 -69 -107 -59 -245 l6 -90 -24 33 c-13 18 -30 46 -36 62 -18 43 -28 36 -36 -28 -7 -57 9 -190 24 -205 4 -4 53 59 109 140 93 134 223 303 302 392 17 19 -24 -39 -92 -130 -224 -300 -398 -580 -543 -874 -61 -122 -64 -132 -64 -200 0 -79 11 -111 28 -80 5 11 49 109 97 219 48 110 123 266 168 348 66 121 84 147 103 147 40 0 150 39 190 68 49 36 81 80 62 86 -7 3 -48 8 -92 11 -43 4 -74 11 -70 15 5 5 65 26 134 47 l125 39 63 94 c133 201 212 392 212 512 0 43 -2 48 -22 48 -13 -1 -55 -13 -94 -29z" 
    }
  )
  ),
);

const store = configureStore();

registerPlugin( 'topic-plugin', {
    icon: smileIcon,
    className: 'topic-bar',
    render: () => {
      return (
        <>
          <PluginSidebarMoreMenuItem
            target="topic-plugin"
          >
            {__('Topic', 'textdomain')}
          </PluginSidebarMoreMenuItem>
          <PluginSidebar
            name="topic-plugin"
            title={__('Topic SEO Content Optimization Tool', 'textdomain')}
            icon={smileIcon}
            className="topic-sidebar"
          >
            <Provider store={store}>
              <MemoryRouter>
                <App/>
              </MemoryRouter>
            </Provider>
          </PluginSidebar>
        </>
      )
    }
  })